import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import { initialUserPortfolio } from './user_portfolio.initial';

const selectPortfolioSection = (state: RootState) =>
    state.user_portfolio?.portfolio ?? initialUserPortfolio.portfolio;

const selectPortfolioFullSection = (state: RootState) =>
    state.user_portfolio?.full ?? initialUserPortfolio.full;

export const selectPortfolioUser = createSelector(
    selectPortfolioSection,
    (section) => section.data_user
);

export const selectPortfolioProperties = createSelector(
    selectPortfolioSection,
    (section) => section.properties
);

export const selectPortfolioSlots = createSelector(
    selectPortfolioSection,
    (section) => section.slots
);

export const selectPortfolioTotals = createSelector(
    selectPortfolioSection,
    (section) => ({
        totalProperties: section.totalProperties,
        totalStatus: section.totalStatus,
        totalSlots: section.totalSlots,
    })
);

export const selectPortfolioUserType = createSelector(
    selectPortfolioSection,
    (section) => section.userType
);

export const selectPortfolioLoading = createSelector(
    selectPortfolioSection,
    (section) => section.loading
);

export const selectPortfolioError = createSelector(
    selectPortfolioSection,
    (section) => section.error
);

export const selectPortfolioPage = createSelector(
    selectPortfolioSection,
    (section) => section.page
);

export const selectPortfolioPageSize = createSelector(
    selectPortfolioSection,
    (section) => section.pageSize
);

export const selectPortfolioLoadedForParameter = createSelector(
    selectPortfolioSection,
    (section) => section.loadedForParameter
);

export const selectPortfolioSlotFilter = createSelector(
    selectPortfolioSection,
    (section) => section.slotFilter
);

export const selectPortfolioSlotsOrder = createSelector(
    selectPortfolioSection,
    (section) => section.slotsOrder
);

export const selectPortfolioPropertyPage = createSelector(
    selectPortfolioSection,
    (section) => section.propertyPage
);

export const selectPortfolioPropertyFilter = createSelector(
    selectPortfolioSection,
    (section) => section.propertyFilter
);

export const selectPortfolioSaving = createSelector(
    selectPortfolioSection,
    (section) => section.saving
);

export const selectPortfolioSaveError = createSelector(
    selectPortfolioSection,
    (section) => section.saveError
);

export const selectPortfolioAssigning = createSelector(
    selectPortfolioSection,
    (section) => section.assigning
);

export const selectPortfolioAssignError = createSelector(
    selectPortfolioSection,
    (section) => section.assignError
);

export const selectPortfolioCreating = createSelector(
    selectPortfolioSection,
    (section) => section.creating
);

export const selectPortfolioCreateError = createSelector(
    selectPortfolioSection,
    (section) => section.createError
);

// ── Carga completa (Asignaciones) ───────────────────────────────────────────

export const selectPortfolioFullSlots = createSelector(
    selectPortfolioFullSection,
    (section) => section.slots
);

export const selectPortfolioFullProperties = createSelector(
    selectPortfolioFullSection,
    (section) => section.properties
);

export const selectPortfolioFullTotals = createSelector(
    selectPortfolioFullSection,
    (section) => ({
        totalSlots: section.totalSlots,
        totalProperties: section.totalProperties,
    })
);

export const selectPortfolioFullLoading = createSelector(
    selectPortfolioFullSection,
    (section) => section.loading
);

export const selectPortfolioFullError = createSelector(
    selectPortfolioFullSection,
    (section) => section.error
);

export const selectPortfolioFullLoadedForParameter = createSelector(
    selectPortfolioFullSection,
    (section) => section.loadedForParameter
);
